define('BookingEngine/app-Passdetails/settings',[],function () {
    return {
        container: '#passdetails',
        submiturl: window.location.protocol + '//' + window.location.host + '/passengerinfossave/',
        getAddressSummariesUrl: window.location.protocol + '//' + window.location.host + '/addresslookup/GetAddressSummaries',
        getFormattedAddressUrl: window.location.protocol + '//' + window.location.host + '/addresslookup/GetFormattedAddress'
    };
});
